import type { RescueStalledAdopterGql } from './rescueQueries';
import type { StalledAdopter } from './types';

/** Maps a `rescueStalledAdopters` entry into the view-model the Text all / Email all modals render. */
export function mapStalledAdopter(adopter: RescueStalledAdopterGql): StalledAdopter {
  return {
    transferIds: adopter.transferIds,
    displayName: adopter.name?.trim() || adopter.emails[0] || 'Adopter (no name on file)',
    petNames: adopter.petNames,
    emails: adopter.emails,
    phoneNumber: adopter.phoneNumber,
    transferredAt: adopter.transferredAt,
    lastTextReminderAt: adopter.lastTextReminderAt,
    smsPreview: adopter.smsPreview,
    smsOptedOut: adopter.smsOptedOut,
  };
}
